// Desert Harvest - UpCart Compatible Recharge Quantity Sync
(function() {
  'use strict';
  
  window.RechargeQuantitySync = {
    initialized: false,
    upCartDetected: false,
    
    init: function() {
      if (this.initialized) return;
      
      console.log('🔄 RechargeQuantitySync: Starting UpCart-compatible sync...');
      
      // Detect UpCart presence
      this.detectUpCart();
      
      // Wait for elements
      this.waitForElements();
      this.initialized = true;
    },
    
    detectUpCart: function() {
      // Check for UpCart indicators
      const upCartChecks = [
        () => window.UpCart,
        () => window.upcart,
        () => document.querySelector('[data-upcart]'),
        () => document.querySelector('.upcart'),
        () => document.querySelector('script[src*="upcart"]')
      ];
      
      this.upCartDetected = upCartChecks.some(check => {
        try { return check(); } catch(e) { return false; }
      });
      
      if (this.upCartDetected) {
        console.log('✅ RechargeQuantitySync: UpCart detected - using compatible mode');
      } else {
        console.log('ℹ️ RechargeQuantitySync: No UpCart detected - using standard mode');
      }
    },
    
    waitForElements: function() {
      let attempts = 0;
      const maxAttempts = 20; // Increased for UpCart compatibility
      
      const checkElements = () => {
        attempts++;
        const quantityInput = document.querySelector('input[name="quantity"]');
        const bundleOptions = document.querySelectorAll('.bundle-option');
        
        if (quantityInput && bundleOptions.length > 0) {
          console.log('✅ RechargeQuantitySync: Setting up bundle sync');
          this.addExplainerMessage();
          this.setupBundleSync(quantityInput);
          this.addPerBottleText();
        } else if (attempts < maxAttempts) {
          console.log(`⏳ RechargeQuantitySync: Waiting... (${attempts}/${maxAttempts})`);
          setTimeout(checkElements, this.upCartDetected ? 1000 : 500); // Longer wait for UpCart
        } else {
          console.warn('⚠️ RechargeQuantitySync: Max attempts reached, elements not found');
        }
      };
      
      // Delay initial check if UpCart is present
      setTimeout(checkElements, this.upCartDetected ? 2000 : 0);
    },
    
    addExplainerMessage: function() {
      const rechargeContainer = document.querySelector('.shopify-block.recharge-subscription-widget');
      if (rechargeContainer && !document.querySelector('.recharge-explainer')) {
        const explainer = document.createElement('div');
        explainer.className = 'recharge-explainer';
        explainer.innerHTML = `
          <div class="shipping-team-note">
            <img src="https://v7m26n-gh.myshopify.com/cdn/shop/files/team_5.png?v=1753819782&width=64" 
                 alt="Dan Florio" class="team-photo">
            <div class="team-content">
              <div class="team-header">
                <span class="team-name">Dan Florio</span>
                <span class="team-role">• Shipping & Logistics</span>
              </div>
              <div class="team-message">
                <strong>💡 Logistics Pro Tip:</strong> Order 6 every 6 months or 12 every 12 months for maximum savings (20-30% volume discounts + free shipping). 
                <strong>How:</strong> Select quantity above, frequency below. Cart shows total per period. 
                <strong>Not interested?</strong> Click 'One-time'.<a href="mailto:info@desertharvest.com">Questions?</a>
              </div>
            </div>
          </div>
        `;
        
        // Insert at the beginning of the container
        rechargeContainer.insertBefore(explainer, rechargeContainer.firstChild);
      }
    },
    
    setupBundleSync: function(quantityInput) {
      const bundleOptions = document.querySelectorAll('.bundle-option');
      
      bundleOptions.forEach(option => {
        option.addEventListener('click', () => {
          // Longer delay for UpCart compatibility
          const delay = this.upCartDetected ? 300 : 100;
          
          setTimeout(() => {
            const bundleQuantity = option.getAttribute('data-quantity');
            if (bundleQuantity) {
              // Store original value to detect changes
              const originalValue = quantityInput.value;
              quantityInput.value = bundleQuantity;
              
              if (this.upCartDetected) {
                // UpCart-compatible event triggering
                this.triggerUpCartCompatibleEvents(quantityInput, bundleQuantity);
              } else {
                // Standard event triggering
                quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
                quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
              
              console.log(`✅ Quantity synced (${this.upCartDetected ? 'UpCart mode' : 'Standard mode'}):`, bundleQuantity);
            }
          }, delay);
        });
      });
    },
    
    triggerUpCartCompatibleEvents: function(quantityInput, quantity) {
      // Multiple event types for maximum compatibility
      const events = ['input', 'change', 'blur', 'keyup'];
      
      events.forEach(eventType => {
        const event = new Event(eventType, { 
          bubbles: true, 
          cancelable: true,
          composed: true 
        });
        
        // Add custom properties that UpCart might look for
        event.upcartCompatible = true;
        event.rechargeSync = true;
        
        quantityInput.dispatchEvent(event);
      });
      
      // Also trigger a custom event that both apps can listen to
      const customEvent = new CustomEvent('recharge:quantity:updated', {
        detail: { quantity: quantity, source: 'bundle-sync' },
        bubbles: true
      });
      document.dispatchEvent(customEvent);
    },
    
    addPerBottleText: function() {
      // Add "/per bottle" to Recharge prices with UpCart compatibility
      const addText = () => {
        const rechargePrices = document.querySelectorAll('recharge-subscription-widget .rc-price');
        rechargePrices.forEach(priceElement => {
          if (!priceElement.textContent.includes('/bottle')) {
            priceElement.innerHTML += '<span style="font-size:12px;color:#666;font-weight:500;"> /bottle</span>';
          }
        });
      };
      
      // More frequent checks when UpCart is present (it may modify DOM more often)
      if (this.upCartDetected) {
        const intervals = [500, 1500, 3000, 5000, 8000];
        intervals.forEach(delay => setTimeout(addText, delay));
        
        // Also set up a periodic check
        const periodicCheck = setInterval(() => {
          addText();
        }, 10000);
        
        // Clear after 2 minutes to avoid memory leaks
        setTimeout(() => clearInterval(periodicCheck), 120000);
      } else {
        // Standard timing for non-UpCart scenarios
        setTimeout(addText, 500);
        setTimeout(addText, 1500);
        setTimeout(addText, 3000);
      }
    }
  };
  
  // Enhanced initialization with UpCart compatibility
  const initializeSync = () => {
    // Wait a bit longer if UpCart might be loading
    const hasUpCartScript = document.querySelector('script[src*="upcart"]');
    const delay = hasUpCartScript ? 1500 : 0;
    
    setTimeout(() => {
      window.RechargeQuantitySync.init();
    }, delay);
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSync);
  } else {
    initializeSync();
  }
  
})();
